<div *ngIf="!isLoading; else spinner">
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="obstacle > 0; else addTitle">Edit Obstacle</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <fieldset class="fieldset-container">
        <legend>Area Information</legend>
        <p>
          <mat-form-field class="edit-obstacle">
            <input matInput
                   placeholder="Height Agl"
                   formControlName="heightAgl"
                   [(ngModel)]="obstacle.heightAgl">
          </mat-form-field>
          <mat-form-field class="edit-obstacle">
            <input matInput
                   placeholder="Obstacle Type *"
                   formControlName="obstacleType"
                   [(ngModel)]="obstacle.obstacleType">
          </mat-form-field>
          <mat-form-field class="edit-obstacle">
            <input matInput
                   placeholder="Distance From End"
                   formControlName="distanceFromEnd"
                   [(ngModel)]="obstacle.distanceFromEnd">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-obstacle">
            <input matInput
                   placeholder="Center Line Offset"
                   formControlName="centerlineOffset"
                   [(ngModel)]="obstacle.centerlineOffset">
          </mat-form-field>
          <mat-form-field class="edit-obstacle">
            <input matInput
                   placeholder="Offset Direction"
                   formControlName="offsetDirection"
                   [(ngModel)]="obstacle.offsetDirection">
          </mat-form-field>
          <mat-form-field class="edit-obstacle">
            <input matInput
                   placeholder="Clearance Slope"
                   formControlName="clearanceSlope"
                   [(ngModel)]="obstacle.clearanceSlope">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-obstacle">
            <input matInput
                   placeholder="Marking"
                   formControlName="marking"
                   [(ngModel)]="obstacle.marking">
          </mat-form-field>
        </p>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Obstacle
</ng-template>
